import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MetricRankingsService {

  private metricRankingsSource = new BehaviorSubject<MetricRankingDetailed[]>(null);
  currentMetricRankings = this.metricRankingsSource.asObservable();

  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, private router: Router, private route: ActivatedRoute, private toastr: ToastrService) { }

  // Grabs all MetricRankings, regardless of Ranking. Not currently in use.
  // getMetricRankings() {
  //   this.http.get(`${this.baseUrl}api/MetricRankings`, {observe: 'response'}).subscribe(response => {
  //     console.log('getMetricRankings');
  //     console.log(response);
  //   });
  // }

  getMetricRankings(rankingId: number) {
    this.http.get(`${this.baseUrl}api/MetricRankings/ByRanking/${rankingId}`, {observe: 'response'}).subscribe(response => {
      let metricRankings: any = response.body;
      this.metricRankingsSource.next(metricRankings);
    });
  }

  // Creates a new empty Ranking on the seasonal-ranking page. The new Ranking will have any currently created metrics assigned to it, but those will not have weights.
    postRanking(newRankName: string) {
        this.http.post(`${this.baseUrl}api/Rankings/CreateNewRankingDefault`, { rankingName: newRankName}, { observe: 'response' }).subscribe(response => {
        let body: any = response.body;
        if (body.rankingId) {
            this.http.post(`${this.baseUrl}api/MetricRankings/CreateNewSetForRanking/` + body.rankingId, {}, { observe: 'response' }).subscribe(response => {
                this.toastr.success('Create, select and weight metrics', 'New Metric Ranking Ranking Set Created');
                this.router.navigate(['/weighting', body.rankingId]);
            });
      }
      this.toastr.success('Create, select and weight metrics','New Ranking Created');
    });
  }

  // // Updates a single MetricRanking. Not in use.
  // putMetricRanking(metricRanking: MetricRanking) {
  //   this.http.put(`${this.baseUrl}api/MetricRankings`, metricRanking, {observe: 'response'}).subscribe(response => {
  //     console.log('putMetricRanking');
  //     console.log(response);
  //   });
  // }

  // Updates all MetricRankings at one time.
  putMetricRankings(metricRankings: MetricRanking[]) {
    this.http.put(`${this.baseUrl}api/MetricRankings/UpdateMetricRankingList`, metricRankings, {observe: 'response'}).subscribe(response => {
      this.toastr.success('Weights have been saved.','Success!')
    });
  }

  // Creates a single new MetricRanking.
  // When this is triggered, the weighting component will check to see if the Metric first and complete that prior to creating the associated MetricRanking.
  postMetricRanking(metricRanking: any) {
    let data: any = {};
    data.rankingId = metricRanking.rankingId;
    data.metricId = metricRanking.metricId;
    this.http.post(`${this.baseUrl}api/MetricRankings`, data, {observe: 'response'}).subscribe(response => {
      if (response.status === 201) {
        this.getMetricRankings(data.rankingId);
      }
    });
  }

  changeMetricRankings(metricRankings) {
    this.metricRankingsSource.next(metricRankings);
  }
}

// Metrics are universal, as all Rankings share Metrics. A MetricRanking is uniquely tied to a Ranking and contains weighting and inclusion status.
export interface MetricRanking {
  metricRankingId?: number,
  rankingId: number,
  metricId: number,
  metricRankingWeight?: number,
  metricEnabled?: boolean
}

export interface MetricRankingDetailed extends MetricRanking {
  metricName?: string,
  metricDescription?: string
}

